var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.84627 7.48322V4.45772C6.84627 3.24752 6.84627 2.64242 7.05869 2.17995C7.24577 1.77258 7.54295 1.44302 7.91029 1.23556C8.32733 1 8.87298 1 9.96428 1H15.4208C16.5121 1 17.0578 1 17.4748 1.23556C17.8415 1.44274 18.1396 1.77333 18.3264 2.17995C18.5388 2.64242 18.5388 3.24752 18.5388 4.45772V10.5087C18.5388 11.7189 18.5388 12.324 18.3264 12.7865C18.1395 13.193 17.8414 13.5236 17.4748 13.7309C17.0578 13.9664 16.5121 13.9664 15.4237 13.9664H12.6925M6.84627 7.48322H4.11801C3.02671 7.48322 2.48106 7.48322 2.06402 7.71878C1.69732 7.9259 1.39919 8.25651 1.21241 8.66317C1 9.12564 1 9.73074 1 10.9409V16.9919C1 18.2021 1 18.8073 1.21241 19.2697C1.39925 19.6763 1.69736 20.0069 2.06402 20.2141C2.48008 20.4497 3.02573 20.4497 4.11509 20.4497H9.57843C10.6668 20.4497 11.2115 20.4497 11.6285 20.2141C11.9952 20.0069 12.2933 19.6763 12.4801 19.2697C12.6925 18.8073 12.6925 18.2032 12.6925 16.9952V13.9664M6.84627 7.48322H9.57453C10.6658 7.48322 11.2115 7.48322 11.6285 7.71878C11.9952 7.92597 12.2933 8.25655 12.4801 8.66317C12.6925 9.12456 12.6925 9.72966 12.6925 10.9377V13.9664",
    stroke: "#F47524",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyActive);
export default __webpack_public_path__ + "static/media/copy-active.090d096a374f28febb002b5ab3dc0c9b.svg";
export { ForwardRef as ReactComponent };